import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

/** Session expired or MFA required mid-session: send the user to the right screen. */
function handleAuthError(error: unknown) {
  if (!(error instanceof ApiError)) return;
  const path = window.location.pathname;
  if (error.status === 401 && !path.startsWith("/login")) {
    const redirect = encodeURIComponent(path + window.location.search);
    window.location.assign(`/login?reason=signed-out&redirect=${redirect}`);
  } else if (error.body?.code === "MFA_ENROLLMENT_REQUIRED" && !path.startsWith("/onboarding")) {
    window.location.assign("/onboarding/security");
  }
}

export function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({ onError: handleAuthError }),
    mutationCache: new MutationCache({ onError: handleAuthError }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Client errors won't succeed on retry.
          if (error instanceof ApiError && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
